import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import {ResponseCode} from "@app/constants/Common";
import {requestSaveCandidateGroup} from "@app/services/CandidateGroupService";
import Select from "react-select";
import {InitSavedListInfo, SavedListLevels, SavedListTabOptions} from "@pages/savedlist/common/Constant";
import {validateSaveCandidateGroup} from "@pages/savedlist/common/ValidateUtils";
import {showMessage} from "@app/constants/Messages";

const CreateCandidateGroupModal = (props) => {
    const [group, setGroup] = useState({...InitSavedListInfo});

    const [isLoading, setIsLoading] = useState(false)
    const {isShow} = props
    const {candidates} = props
    const {allCandidateIds} = props
    const {onClose} = props

    useEffect(() => {
        setGroup({...InitSavedListInfo})
    }, []);

    const onSaveGroup = () => {
        if (!validateSaveCandidateGroup(group)) {
            return;
        }

        setIsLoading(true)
        group.candidate_ids = allCandidateIds
        if (!group.candidate_ids || group.candidate_ids.length === 0) {
            candidates.forEach(can => {
                group.candidate_ids.push(can.general.id)
            })
        }

        const body = {...group}
        body.tab = group.tab.value

        requestSaveCandidateGroup(body).then((res) => {
            console.log(`Response-create candidate:${JSON.stringify(res)}`);
            if (res.sts_code === ResponseCode.SUCCESS) {
                onClose(true)
            } else if (res.sts_code === ResponseCode.EXISTS_SAVED_LIST) {
                showMessage("Tên saved list đã tồn tại trên phần mềm", false, true, true)
            } else {
                showMessage("Tạo saved list mới thất bại", false, true, true)
            }
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const setGroupItem = (event) => {
        group[event.target.name] = event.target.value
        setGroup({...group})
    }

    const setTabItem = (values) => {
        group.tab = values
        setGroup({...group})
    }

    const onCloseModal = () => {
        setGroup(InitSavedListInfo)
        onClose()
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={onCloseModal}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Nhập thông tin saved list mới</Modal.Title>
                    <Button variant='secondary' onClick={onCloseModal}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Tên saved list</label>
                                <input type='text' className='form-control' placeholder='Tên saved list'
                                       value={group.name}
                                       name={'name'} onChange={event => setGroupItem(event)}/>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <div style={{width: '100%'}}>
                                    <label className={'w-100'}>Tên Tab</label>
                                    <Select options={SavedListTabOptions}
                                            value={group.tab}
                                            name={'tab'}
                                            placeholder={'Tên Tab'}
                                            onChange={value => {
                                                setTabItem(value);
                                            }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Level</label>
                                <select className={`form-control`}
                                        value={group.level}
                                        name={'level'}
                                        placeholder={'Level'}
                                        onChange={event => setGroupItem(event)}>
                                    {SavedListLevels.map(item => (
                                        <option value={item}>{item}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className='col-sm-12'>
                            <div className='form-group'>
                                <label className={'w-100'}>Notes</label>
                                <input type='text' className='form-control' placeholder='Notes'
                                       value={group.notes}
                                       name={'notes'} onChange={event => setGroupItem(event)}/>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button type='button'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={
                                isLoading
                            }
                            onClick={() => {
                                onSaveGroup()
                            }}
                            >
                        <i className='fas fa-save mr-2'/>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CreateCandidateGroupModal;
